export default {
      id: "check-usage",
      viewBox: "0 0 17 13",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#check",
      toString: function () {
        return this.url;
      }
    }